import {Route, Routes, useLocation} from 'react-router';

import SlideTransition from '@/components/SlideTransition/SlideTransition';
import ROUTE_PATHS from '@/consts/routePaths';
import BadgesPage from '@/containers/BadgesPage/BadgesPage';
import InProgressPage from '@/containers/InProgressPage/InProgressPage';

const AppRoutes = () => {
    const location = useLocation();

    return (
        <SlideTransition>
            <Routes location={location}>
                <Route path={ROUTE_PATHS.BADGES} element={<BadgesPage />} />
                <Route path={ROUTE_PATHS.IN_PROGRESS} element={<InProgressPage />} />
            </Routes>
        </SlideTransition>
    );
};

export default AppRoutes;
